import React, { FC, useCallback, useMemo } from 'react';
import { FileRejection } from 'react-dropzone';
import useTranslation from '../../../hooks/useTranslation';

import { StyledErrorMessage, StyledErrorTitle, StyledErrorText } from './Upload.styles';

export interface UploadErrorProps {
  errorType: string;
  title: string;
  fileRejections: FileRejection[];
}

const UploadError: FC<UploadErrorProps> = ({ title, errorType, fileRejections }) => {
  const { t } = useTranslation('Core.Upload');

  const getRejectedFiles = useCallback((type: string) => (
    fileRejections.reduce((result, { file: { name }, errors }) => {
      if (errors.some(({ code }) => code === type)) {
        result.push(name);
      }
      return result;
    }, [])
  ), [fileRejections]);

  const rejectedFiles = useMemo(() => getRejectedFiles(errorType), [errorType, getRejectedFiles]);

  if (rejectedFiles.length === 0) {
    return null;
  }

  return (
    <StyledErrorMessage>
      <StyledErrorTitle>{title || t(`errors.${errorType}`)}</StyledErrorTitle>
      {rejectedFiles.map((path: string, index: number) => (
        // eslint-disable-next-line react/no-array-index-key
        <StyledErrorText key={`${path}${index}`}>{path}</StyledErrorText>
      ))}
    </StyledErrorMessage>
  );
};

export default UploadError;
